import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="sticky left-[264px] w-[80%] bg-[#F4F5F6] z-50 font-nohemi">
      <div className="px-3 py-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-between">
          <div className="mx-2 my-4 text-xs font-normal text-[#626C70]">
            <p>Copyright &copy; {new Date().getFullYear()} - Lynklux</p>
          </div>
          <div className="mx-2 my-4 text-xs font-normal text-[#626C70]">
            <Link to="#">Documentation .</Link> <Link to="#">Privacy Policy .</Link>{' '}
            <Link to="faq">FAQ</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
